import clsx from 'clsx'
import type { PropsWithChildren } from 'react'

import type { PropsWithClassName } from '@fv/client-types'

type FooterBarProps = PropsWithClassName<{
  absolute?: boolean
  jc?: boolean
  theme?: 'light-blue' | 'gray'
}> &
  PropsWithChildren

export const FooterBar = ({
  className,
  theme,
  children,
  jc,
  absolute,
}: FooterBarProps) => {
  const themeClasses = {
    'light-blue': 'bg-fv-blue-50 border-fv-blue-200',
    gray: 'bg-fv-gray-200',
  }

  const themeClass = theme
    ? themeClasses[theme]
    : 'bg-fv-blue-100 border-fv-blue-300'

  return (
    <div
      className={clsx(
        'px-6 py-4 fa-width-auto mt-auto flex items-center border-t-2',
        themeClass,
        jc && 'justify-center',
        absolute && 'absolute bottom-0 left-0 right-0 z-10',
        className,
      )}
    >
      {children}
    </div>
  )
}
